import React from "react";

export function PhoneIcon(): React.ReactElement {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5 1.6214H7.5C6.12 1.6214 5 2.66528 5 3.9515V19.7962C5 21.0824 6.12 22.1263 7.5 22.1263H15.5C16.88 22.1263 18 21.0824 18 19.7962V3.9515C18 2.66528 16.88 1.6214 15.5 1.6214ZM11.5 21.1942C10.67 21.1942 10 20.5697 10 19.7962C10 19.0226 10.67 18.3981 11.5 18.3981C12.33 18.3981 13 19.0226 13 19.7962C13 20.5697 12.33 21.1942 11.5 21.1942ZM7 17.4661H16V4.41752H7V17.4661Z"
        fill="black"
      />
    </svg>
  );
}
